<template>
  <carousel
    class="carousel-exp"
    ref="carouselSelector"
    :navigationEnabled="true"
    :per-page="1"
    :pagination-enabled="false"
    :loop="true"
    :autoplay="true"
    :autoplay-timeout="5000"
    :minSwuipeDistance="2"
    navigationNextLabel='<img  class="banner__pass-d direita-d" src="/img/direita.png" />'
    navigationPrevLabel='<img  class="banner__pass-d esquerda-d" src="/img/esquerda.png" />'
  >
    <slide>
      <div
        class="banner__image_exp"
        :style="'background-image: url(' + banner1 + ')'"
      ></div>
    </slide>
    <slide>
      <div
        class="banner__image_exp"
        :style="'background-image: url(' + banner2 + ')'"
      ></div>
    </slide>
    <slide>
      <div
        class="banner__image_exp"
        :style="'background-image: url(' + banner3 + ')'"
      ></div>
    </slide>
    <slide>
      <div
        class="banner__image_exp"
        :style="'background-image: url(' + banner4 + ')'"
      ></div>
    </slide>
    <slide>
      <div
        class="banner__image_exp"
        :style="'background-image: url(' + banner5 + ')'"
      ></div>
    </slide>
    <slide>
      <div
        class="banner__image_exp"
        :style="'background-image: url(' + banner6 + ')'"
      ></div>
    </slide>
    <slide>
      <div
        class="banner__image_exp"
        :style="'background-image: url(' + banner7 + ')'"
      ></div>
    </slide>
    <slide>
      <div
        class="banner__image_exp"
        :style="'background-image: url(' + banner8 + ')'"
      ></div>
    </slide>
    <slide>
      <div
        class="banner__image_exp"
        :style="'background-image: url(' + banner9 + ')'"
      ></div>
    </slide>
  </carousel>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  props: ["banners"],
  data() {
    return {
      width: screen.width,
      banner1: "/img/carousel/um.png",
      banner2: "/img/carousel/dois.png",
      banner3: "/img/carousel/tres.png",
      banner4: "/img/carousel/quatro.png",
      banner5: "/img/carousel/cinco.png",
      banner6: "/img/carousel/seis.png",
      banner7: "/img/carousel/sete.png",
      banner8: "/img/carousel/oito.png",
      banner9: "/img/carousel/nove.png",
    };
  },
  components: {
    Carousel,
    Slide,
  },
};
</script>

<style lang="scss" scoped>
.carousel-exp {
  background-color: transparent !important;
  border: none !important;
  margin-bottom: 50px;
  width: 300px;
  height: 400px;
}
.banner__image_exp {
  background-position: top;
  background-size: contain;
  background-repeat: no-repeat;
  width: 300px;
  height: 400px;
}
.banner__pass-d {
  margin-top: -15px;
  @media (max-width: 1500px){
    margin-top: 50px;
  }
  @media (max-width: 996px) {
    margin-top: -200px;
    max-width: 50px;
    max-height: 50px;
  }
  @media (max-width: 775px) {
    margin-top: 0px;
  }
  @media (max-width: 500px){
    max-width: 30px;
    max-height: 30px;
  }
}
.direita-d{
  @media (max-width: 775px){
  margin-left: -25px;
  }
}
.esquerda-d{
  @media (max-width: 775px){
  margin-right: -55px;
  }
}
</style>
